import { useEffect, useState } from "react";

const STORAGE_KEY = "mm-theme";

function getInitialTheme() {
    if (typeof window === "undefined") return "dark";
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
    return "dark";
}

// Estado compartido a nivel de módulo: así todos los componentes que usan
// useTheme() (Navbar, Musicos, etc.) ven el mismo valor y se actualizan
// juntos al cambiar de tema, en vez de tener cada uno su propia copia.
let currentTheme = getInitialTheme();
const listeners = new Set();

function applyDocumentClass(theme) {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
}

// Aplica la clase inicial apenas se carga el módulo (equivalente al efecto
// que antes corría en el primer componente que montaba el hook).
applyDocumentClass(currentTheme);

function setGlobalTheme(theme) {
    currentTheme = theme;
    applyDocumentClass(theme);
    if (typeof window !== "undefined") {
        localStorage.setItem(STORAGE_KEY, theme);
    }
    listeners.forEach((listener) => listener(theme));
}

export function useTheme() {
    const [theme, setThemeLocal] = useState(currentTheme);

    useEffect(() => {
        // Por si el tema cambió entre el render inicial y el montaje.
        setThemeLocal(currentTheme);
        listeners.add(setThemeLocal);
        return () => listeners.delete(setThemeLocal);
    }, []);

    const toggle = () => setGlobalTheme(currentTheme === "dark" ? "light" : "dark");
    const setTheme = (t) => setGlobalTheme(t);

    return { theme, toggle, setTheme };
}
